/**
 * PREÇO DE VENDA de uma variação — a promoção só vale quando é promoção.
 *
 * O sistema inteiro lia `promoPrice ?? price`, e isso mente por um detalhe do
 * `??`: ele só cai no preço cheio quando a promoção é `null`/`undefined`.
 * `promo_price = 0` — que é o que as telas gravam quando alguém digita "0" no
 * campo de promoção pra dizer "não tem" — passa pelo `??` e o item vai pra
 * venda a **R$ 0,00**.
 *
 * Não era hipótese: em 11/09/2026, 59 variações de três organizações em
 * produção (Boné Liso TRUCKER inteiro na MT Personalizados, BASE BAÚ na
 * Viella, todas as excursões da Estrela Dalva) estavam com `promo_price = 0`
 * e entravam a zero na nova venda, no PDV e no cálculo do servidor — venda
 * fechada de graça, não erro de exibição. Nenhuma org tinha uma promoção
 * legítima (`promo_price > 0` = 0 registros no banco inteiro).
 *
 * A regra aqui é a MESMA que o assistente de item já aplicava ao GRAVAR ("só
 * vai promoção que é promoção"): valor ausente, zero, negativo ou maior/igual
 * ao preço cheio não é promoção — é o preço cheio. A diferença é que agora ela
 * vale também na LEITURA, que é o lado que decide quanto o cliente paga.
 *
 * Aceita `string` porque o numeric do Postgres chega como string pelo Drizzle,
 * e as telas repassam o valor cru da API.
 */

type Valor = string | number | null | undefined;

function num(v: Valor): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}

/**
 * A promoção VÁLIDA desta variação, ou `null` quando não há uma.
 *
 * Promoção que não desconta nada (igual ou acima do preço cheio) também é
 * `null`: ela viraria um riscado mentiroso na vitrine, e é exatamente o que a
 * criação de variação já recusava gravar.
 */
export function promocaoValida(price: Valor, promoPrice: Valor): number | null {
  const cheio = num(price);
  const promo = num(promoPrice);
  if (promo === null || promo <= 0) return null;
  if (cheio !== null && promo >= cheio) return null;
  return promo;
}

/** O que o cliente paga por uma unidade: a promoção quando ela é real. */
export function precoDeVenda(v: { price: Valor; promoPrice?: Valor }): number {
  return promocaoValida(v.price, v.promoPrice) ?? num(v.price) ?? 0;
}
